import { DOCUMENT_STATUSES } from 'store/api/types/assets';

/** Alias приложения в `coreOrganizationParticipations.my.application`. */
export const ASSETS_APPLICATION_ALIAS = 'assets';

/**
 * Справочники волны 1 захардкожены осознанно: `dictionaries-svc` для Активов
 * (US-01-03) в объём не входит, а фильтр и мастер должны работать уже сейчас.
 */
export const ENTITY_TYPES = ['Изделие', 'Техместо'] as const;

export const PASSPORT_STATUSES = DOCUMENT_STATUSES;

export type EntityType = (typeof ENTITY_TYPES)[number];

/**
 * Колонки списка ЦП. Ключ колонки одновременно является ключом перевода.
 *
 * По умолчанию показываем минимум из SPEC 4.3; остальные колонки макета
 * (тип актива, артикул, инвентарный номер, место установки) доступны в настройках
 * таблицы — иначе строка не помещается в экран.
 */
export const PASSPORT_DEFAULT_COLUMNS = [
  'number',
  'name',
  'entityType',
  'status',
  'lifecycleStatus',
  'manufacturer',
  'factoryNumber',
  'pzp',
];

export const PASSPORT_COLUMNS = [
  'number',
  'name',
  'entityType',
  'type',
  'productNumber',
  'status',
  'lifecycleStatus',
  'manufacturer',
  'factoryNumber',
  'inventoryNumber',
  'location',
  'pzp',
];

/**
 * Классы бейджа статуса берём из общего `components/status`: цвета и форма
 * должны совпадать с договорами и топливом, а подпись — из словаря КТМ-А.
 */
export const PASSPORT_STATUS_VARIANT: Record<string, string> = {
  DRAFT: 'draft',
  PENDING_APPROVAL: 'expectation',
  APPROVED: 'completed',
  SIGNED: 'active',
  REJECTED: 'blocked',
  CANCELLED: 'blocked',
  EXPIRED: 'secondary-expectation',
};
